import React,{useState} from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet
} from '@react-pdf/renderer';
import chunk from 'lodash/chunk'; // Tambahkan lodash

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 8,
    fontFamily: 'Helvetica',
    position: 'relative',
  },
  title: {
    fontSize: 12,
    marginBottom: 10,
    textAlign: 'center'
  },
  sectionTitle: {
    fontSize: 8,
    marginTop: 6,
    marginBottom: 2,
    fontWeight: 'bold'
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderColor: "#ccc",
    paddingVertical: 2,
    fontSize:8 
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: "#000",
    paddingVertical: 3,
    backgroundColor: "#eee"
  },
  cell: {
    paddingHorizontal: 3
  },
  colDate: { width: "10%" },
  colChartcode: { width: "10%" },
  colChartdesc: { width: "60%" },
  colDebit: { width: "10%", textAlign: "right" },
  colCredit: { width: "10%", textAlign: "right" },  
  footerRow: {
    flexDirection: "row",
    backgroundColor: "#f9f9f9",
    borderTopWidth: 1,
    borderColor: "#000",
    paddingTop: 2
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    top: 10,
    right: 30,
    textAlign: 'right',
    color: 'grey'
  }
});

const groupBy = (arr, key1, key2) => {
  return arr.reduce((acc, item) => {
    const groupKey = `${item[key1]}||${item[key2]}`;
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(item);
    return acc;
  }, {});
};

const formatCurrency = val => Number(val || 0).toLocaleString('id-ID');

const formatDate = str => {
  try {
    return new Date(str).toLocaleDateString('id-ID', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return str;
  }
};

  const MyReportsumjurnal = ({ data = [],tanggalDari,tanggalSampai,userBy }) => {
  const groupedData = groupBy(data, 'doc_no', 'ket');
  const [date,setDate] = useState(new Date().toLocaleString())

  const rows = [];

  Object.entries(groupedData).forEach(([key, records]) => {
    const [doc, ket] = key.split('||');
    const totalDebit = records.reduce((sum, r) => sum + (r.debit || 0), 0);
    const totalCredit = records.reduce((sum, r) => sum + (r.credit || 0), 0);
         

    rows.push(
      <Text key={`${key}-title`} style={styles.sectionTitle}>
        {doc}  -  {ket}
      </Text>
    );

    records.forEach((r, i) => {
      rows.push(
        <View style={styles.tableRow} key={`${key}-row-${i}`}>
          <Text style={[styles.cell, styles.colDate]}>{formatDate(r.date_voucher)}</Text>
          <Text style={[styles.cell, styles.colChartcode]}>{r.chart_account_code}</Text>
          <Text style={[styles.cell, styles.colChartdesc]}>{r.chart_account_desc}</Text>          
          <Text style={[styles.cell, styles.colDebit]}>{formatCurrency(r.debit)}</Text>
          <Text style={[styles.cell, styles.colCredit]}>{formatCurrency(r.credit)}</Text>           
        </View>
      );
    });

    rows.push(
      <View style={styles.footerRow} key={`${key}-subtotal`}>
        <Text style={[styles.cell, styles.colDate]}>Sub Total</Text>
        <Text style={[styles.cell, styles.colChartcode]}></Text>
        <Text style={[styles.cell, styles.colChartdesc]}></Text>
        <Text style={[styles.cell, styles.colDebit]}>{formatCurrency(totalDebit)}</Text>
        <Text style={[styles.cell, styles.colCredit]}>{formatCurrency(totalCredit)}</Text>
         
      </View>
    );
  });

  const rowsPerPage = 50; // bisa kamu sesuaikan tergantung tinggi konten
  const pages = chunk(rows, rowsPerPage);

  return (
    <Document>
      {pages.map((rowsChunk, idx) => (
        <Page key={idx} size="A4" orientation="portrait" style={styles.page}>
          <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `Halaman: ${pageNumber} dari ${totalPages}`} fixed />
          <Text style={styles.title}>Laporan Summary Jurnal &nbsp;&nbsp; dari : {tanggalDari} &nbsp;&nbsp; sampai : {tanggalSampai}</Text>
          <Text> 
                Tanggal : {date} &nbsp;&nbsp;&nbsp;&nbsp;user by : {userBy}
          </Text>
          <View style={styles.tableHeader} fixed>
            <Text style={[styles.cell, styles.colDate]}>Tanggal</Text>
            <Text style={[styles.cell, styles.colChartcode]}>Acc.Code</Text>
            <Text style={[styles.cell, styles.colChartdesc]}>Acc.Desc</Text>
            <Text style={[styles.cell, styles.colDebit]}>Debit</Text>
            <Text style={[styles.cell, styles.colCredit]}>Credit</Text>             
          </View>
          {rowsChunk}
        </Page>
      ))}
    </Document>
  );
};

export default MyReportsumjurnal;
